import React from "react";
import adminActionType from "components/Profile/AdminLinks/adminActionType";
import { Typography } from "@theconversation/ui";
import { track } from "lib/analytics";

import styles from "./styles.scss";

const GOOGLE_ANALYTICS_CATEGORY = "Profile Admin Actions";
const GOOGLE_ANALYTICS_ACTION = "Click";

export default function Link({ adminAction }) {
  const { icon, label, path, trackAction } = adminAction;
  const iconElement = <i className={`icon-${icon}`} />;
  const onClick = () => track(GOOGLE_ANALYTICS_CATEGORY, GOOGLE_ANALYTICS_ACTION, trackAction);

  return (
    <Typography variant="caption">
      <a className={styles.link} href={path} onClick={onClick}>{iconElement}{label}</a>
    </Typography>
  );
}

Link.propTypes = {
  adminAction: adminActionType.isRequired,
};
